import { Histogram } from '../../../Common/Charts/Histogram';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const BirthWeigth = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <Histogram
            title={'Pesos ao Nascer'}
            horizontal={false}
            subtitles={chartData?.birthWeight?.map((item) => item.description)}
            values={chartData?.birthWeight?.map((item) => item.total  ||  0)}
        />
    );
};
